import { handleCheckingProgress } from './api';
import { PHOTOS_STATUS } from './config';
import { findMuatalItem } from './findPhotoCode';
import { reducePhotoCodeByPosition } from './reducerArr';

export const processOfflineFunction = async (
  sessionID,
  getAllImgsOffline,
  bgJob,
  getPhotosState,
  intl,
  locale
) => {
  try {
    let tempArr = [];
    let getData = getPhotosState
      ? getPhotosState
      : await handleCheckingProgress(sessionID);
    const { data } = getData;
    const { missing } = data.photos;
    const missingResult = await reducePhotoCodeByPosition(
      missing,
      bgJob,
      PHOTOS_STATUS.MISSING,
      intl,
      locale
    );
    tempArr =
      !!getAllImgsOffline &&
      getAllImgsOffline.length > 0 &&
      (await findMuatalItem(missingResult, getAllImgsOffline, sessionID));
    return tempArr;
  } catch (error) {
    console.log('error', error);
  }
};
